import { api } from '../api/client';
import type { ProgramView } from '../programs/types';

export type ProgramPackage = {
  id: string;
  name: string;
  programCount: number;
};

export type PackageItem = {
  id: string;
  name: string;
  kind: string;
};

export async function fetchPackages(): Promise<ProgramPackage[]> {
  return api<ProgramPackage[]>('/packages', { token: true });
}

export async function createPackage(name: string): Promise<ProgramPackage> {
  return api<ProgramPackage>('/packages', {
    method: 'POST',
    token: true,
    body: { name },
  });
}

export async function renamePackage(packageId: string, name: string): Promise<ProgramPackage> {
  return api<ProgramPackage>(`/packages/${encodeURIComponent(packageId)}`, {
    method: 'PUT',
    token: true,
    body: { name },
  });
}

export async function fetchPackageItems(packageId: string): Promise<PackageItem[]> {
  return api<PackageItem[]>(`/packages/${encodeURIComponent(packageId)}/items`, { token: true });
}

export async function addProgramToPackage(
  packageId: string,
  programId: string,
): Promise<PackageItem> {
  return api<PackageItem>(`/packages/${encodeURIComponent(packageId)}/items`, {
    method: 'POST',
    token: true,
    body: { programId },
  });
}

export async function applyPackage(
  packageId: string,
  learnerId: string | null,
): Promise<ProgramView[]> {
  const q = learnerId ? `?learnerId=${encodeURIComponent(learnerId)}` : '';
  return api<ProgramView[]>(`/packages/${encodeURIComponent(packageId)}/apply${q}`, {
    method: 'POST',
    token: true,
  });
}

export async function removePackageItem(packageId: string, itemId: string): Promise<void> {
  return api<void>(
    `/packages/${encodeURIComponent(packageId)}/items/${encodeURIComponent(itemId)}`,
    { method: 'DELETE', token: true },
  );
}

export async function deletePackage(packageId: string): Promise<void> {
  return api<void>(`/packages/${encodeURIComponent(packageId)}`, {
    method: 'DELETE',
    token: true,
  });
}
